import { environment } from '../../../../../environments/environment'
import {
	Component,
	OnInit,
	ViewChild,
	Output,
	EventEmitter,
	Input
} from '@angular/core'
import { NotificationService } from 'src/app/services/notification.service'
import { NgForm } from '@angular/forms'
import { PlantingService } from 'src/app/services/planting.service'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { getLoggedUser } from 'src/app/_helpers/LocalStorage'
import { PlantingDetailsSchedule } from 'src/app/models/Planting'

@Component({
	selector: 'app-schedule-planting',
	templateUrl: './schedule-planting.component.html'
})
export class SchedulePlantingComponent implements OnInit {
	constructor(
		public notificationService: NotificationService,
		private plantingService: PlantingService
	) { }

	@Input() public idMongo: string
	@Output() public closePlantingDetails: EventEmitter<any> = new EventEmitter()
	@Output() public getPlanting: any = new EventEmitter()
	@Output() public removedPlanting: EventEmitter<any> = new EventEmitter()

	@ViewChild('form') public form: NgForm
	public plantingSelected: PlantingDetailsSchedule

	public loading: boolean = false
	public openDelete: boolean = false
	public enableSalveButton: boolean = false
	public isAdmin: boolean = false

	public sessionUser: UserAdmin = getLoggedUser()
	public justifyCancel: string = ''

	public async ngOnInit(): Promise<void> {
		this.isAdmin = Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))
		this.plantingSelected = await this.plantingService.getPlantingDetails(this.idMongo).toPromise()
	}

	public closeModal(): void {
		this.closePlantingDetails.emit()
	}

	public openDeleteModal(): void {
		this.openDelete = true
	}

	public closeDeleteModal(): void {
		this.openDelete = false
	}

	public async removePlanting() {
		const plantingRemove = this.plantingSelected

		const response: any = await this.plantingService.removeToPageSchedule(plantingRemove.idMongo).toPromise()
		this.notificationService.notify(response.message, 200)

		this.closeModal()

		this.removedPlanting.emit()
	}

	public async savePlanting() {
		try {
			const response: any = await this.plantingService.updatePlantingOpportunity(
				this.plantingSelected
			).toPromise()

			this.notificationService.notify(response.message, 200)

			this.closeModal()

			this.getPlanting.emit()
		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public enableSalve() {
		if (!this.plantingSelected.address) {
			this.enableSalveButton = false
		} else {
			this.enableSalveButton = true
		}
	}
}
